import { render, staticRenderFns } from "./PlanTableSkeleton.vue?vue&type=template&id=0c5c149e"
import script from "./PlanTableSkeleton.vue?vue&type=script&lang=js"
export * from "./PlanTableSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports